<template lang="pug">
v-container.mb-6
  new-content-dialog(v-model="dialog" :product="product" :firstPage="!content" :newLocales="newLocales" @added="contentAdded")
  delete-dialog(v-model="deleteDialog" @confirm="deleteContent")
  v-dialog
    v-card
  v-row(v-if="!content")
    v-col
      v-btn(block large color="orange" @click="dialog=true") Add Product Page
  v-row(v-if="content")
    v-col
      v-select(label="Select Page Language" v-model="activeLanguage" :items="languages" item-text="display" item-value="id")
    v-col.shrink.px-0(v-if="newLocales.length > 0")
      v-tooltip(top)
        template(v-slot:activator="{ on }")
          v-btn.mt-4.caption(icon v-on="on" @click="dialog = true")
            v-icon mdi-plus
        span Add New Page Language
    v-col.shrink.px-0(v-if="activeLanguage !== 1")
      v-tooltip(top)
        template(v-slot:activator="{ on }")
          v-btn.mt-4.caption(icon v-on="on" @click="deleteDialog = true")
            v-icon mdi-trash-can-outline
        span Delete Current Page Language
    v-spacer
    v-col.shrink(v-if="content && content.slug")
      v-btn.info(:href="pageURL" target="_blank")
        v-icon mdi-eye
        | &nbsp;VIEW PAGE
  v-row(v-if="content")
    v-col(cols="12")
      v-tabs(color="orange" vertical)
        v-tab Basic
        v-tab SEO
        v-tab Copywriting
        v-tab-item.pa-4(:transition="false" :reverse-transition="false")
          v-select(v-if="$store.state.groups.includes('Marketing')" label="Status" v-model="content.status" :items="statuses" item-text="text" item-value="value")
          v-text-field(v-model="content.name" label="Display Product Name" counter="30")
          v-text-field(v-model="content.special" label="Special Tag" counter="30" maxlength="30")
          v-select(v-model="content.default_option.id" label="Default Price" :items="defOptions" item-text="text" item-value="value")
          p.subtitle-1 Benefits
          template(v-for="(b, index) in benefits")
            v-row
              v-col.py-0(cols="11")
                v-text-field.mb-4(v-model="b.text" label="Text" solo hide-details)
              v-col.pt-2(cols="1")
                v-btn(icon)
                  v-icon(@click="removeBenefit(b, index)" large) mdi-delete
            v-divider.mt-3.mb-6(v-if="benefits.length > 1")
          v-btn(color="orange" small @click="allBenefits.push({ text: '', locale: activeLanguage })") Add Benefit
        v-tab-item.pa-4(:transition="false" :reverse-transition="false")
          v-text-field(v-model="content.slug" label="URL Slug")
          v-text-field(v-model="content.page_title" label="Page Title" :placeholder="content.name")
          v-textarea(v-model="content.page_description" label="Page Description" :placeholder="content.special")
        v-tab-item.pa-4(:transition="false" :reverse-transition="false")
          v-select(v-model="activeSections[content.id]" :items="titles" item-value="text" color="orange" item-color="orange" label="Select Sections" multiple chips small-chips @change="updateSections" hint="These selected sections will be displayed on the page" :persistent-hint="true")
          v-card.mb-2.elevation-0(v-for="s in activeSections[content.id]" :key="s")
            v-card-title
              | {{ s }}
              v-spacer
              v-btn(icon)
                v-icon(@click="$set(titles.filter(t => t.text === s)[0], 'editContent', !titles.filter(t => t.text === s)[0].editContent)") {{ titles.filter(t => t.text === s)[0].editContent ? 'mdi-content-save' : 'mdi-pencil' }}
            v-card-actions
              div.px-2(v-if="!titles.filter(t => t.text === s)[0].editContent" v-html="content.details.filter(cd => cd.title === s)[0].content")
              v-row(v-else)
                v-col.py-0(cols="12")
                  editor.white.black--text(v-model="content.details.filter(cd => cd.title === s)[0].content" :imageUploadParams="{ product: $route.params.productID }")
            //- v-textarea(v-model="d.content" label="Content" auto-grow solo light)
          template(v-if="product.vertical === 'JT' || product.vertical === 'PT'")
            p.mt-12.subtitle-1 Itinerary
            template(v-for="(i, index) in content.itineraries")
              v-row
                v-col.py-0(cols="11")
                  v-text-field.mb-4(v-model="i.title" label="Title" solo hide-details)
                v-col.pt-2(cols="1")
                  v-btn(icon)
                    v-icon(@click="content.itineraries.splice(index, 1)" large) mdi-delete
              //- v-textarea(v-model="i.content" label="Content" auto-grow solo)
              v-row
                v-col.pt-0(cols="12")
                  editor.white.black--text(v-model="i.content" :imageUploadParams="{ product: $route.params.productID }")
              //- v-file-input(show-size label="Itinerary Image" prepend-icon="mdi-camera" solo)
              v-divider.mt-3.mb-6(v-if="content.itineraries.length > 1")
            v-btn(color="red" @click="content.itineraries.push({ title: '', content: ''})") Add Itinerary
            p.mt-12.subtitle-1 Unique Selling Points
            template(v-for="(u, index) in content.unique_selling_points")
              v-row.mb-n3
                v-col.py-0(cols="11")
                  v-text-field(v-model="u.title" label="Title" solo)
                v-col.pt-2(cols="1")
                  v-btn(icon)
                    v-icon(@click="content.unique_selling_points.splice(index, 1)" large) mdi-delete
              //- v-textarea(v-model="u.content" label="Description" auto-grow solo)
              v-row
                v-col.pt-0(cols="12")
                  editor.white.black--text(v-model="u.content" :imageUploadParams="{ product: $route.params.productID }")
              //- v-file-input(show-size label="USP Image" prepend-icon="mdi-camera" solo)
              v-divider.mt-3.mb-6(v-if="content.unique_selling_points.length > 1")
            v-btn(color="red" @click="content.unique_selling_points.push({title: '', content: ''})") Add USP
  v-footer(app inset padless color="transparent")
    v-row(justify="center")
      v-col(cols="12" style="background-color: #424242")
        v-row(justify="center")
          v-col.py-0(cols="8")
            v-btn(block color="success" @click="submitContent") Save Content
            span.caption.warning--text(v-if="!saveEnabled") Warning: Currently being edited by other user
</template>

<script>
import Editor from '@/components/Editor'
import NewContentDialog from '@/components/NewContentDialog'
import DeleteDialog from '@/components/DeleteDialog'

export default {
  name: 'ContentTab',
  components: { Editor, NewContentDialog, DeleteDialog },
  props: ['product', 'language', 'saveEnabled'],
  data: () => ({
    dialog: false,
    deleteDialog: false,
    statuses: [
      {text: 'Draft', value: 'draft'},
      {text: 'Published', value: 'published'},
      {text: 'Inactive', value: 'inactive'}
    ],
    availableLocales: [],
    contents: [],
    activeSections: {},
    activeLanguage: 1,
    content: null,
    allBenefits: [],
    titles: [
      {text: 'General info', editContent: false},
      {text: 'How to use', editContent: false},
      {text: 'How to go', editContent: false},
      {text: 'Inclusion', editContent: false},
      {text: 'Exclusion', editContent: false},
      {text: 'Operation hours', editContent: false},
      {text: 'Cancellation policy', editContent: false},
      {text: 'Terms and conditions', editContent: false}
    ],
    prodTitle: [],
    cities: [],
    defOptions: []
  }),
  computed: {
    languages() {
      return this.contents.map(c => {
        const locale = { ...c.locale }
        if (locale.name.includes('en')) {
          locale.display = 'English'
        } else if (locale.name.includes('ms')) {
          locale.display = 'Malay'
        } else {
          locale.display = locale.name
        }
        return locale
      })
    },
    benefits () {
      return this.allBenefits.filter(b => b.locale === this.activeLanguage)
    },
    pageURL () {
      return process.env.VUE_APP_WEB_URL + '/' + this.content.slug + '/?preview=1'
    },
    newLocales () {
      const existingLocales = this.contents.map(c => {
        return c.locale.id
      })
      return this.availableLocales.filter(l => !existingLocales.includes(l.id))
    }
  },
  watch: {
    activeLanguage () {
      this.setActiveContent()
    }
  },
  mounted() {
    this.fetchAvailableLocales()
    this.fetchContents()
    // this.fetchContent()
    this.fetchDefaultOption()
    this.fetchBenefits()
  },
  methods: {
    fetchAvailableLocales () {
      this.$axios.get('/locales/?ordering=id')
        .then(resp => {
          this.availableLocales = resp.data.results
        })
    },
    fetchContents () {
      let id = this.$route.params.productID
      this.$axios.get(`/contents/?product=${id}&ordering=locale`)
        .then(resp => {
          this.contents = resp.data.results
          if (this.contents.length > 0) {
            this.setActiveContent()
          }
        })
    },
    setActiveContent () {
      const content = this.contents.filter(c => c.locale.id === this.activeLanguage)[0]
      if (!content.default_option) {
        content.default_option = {}
      }
      // this.prodTitle = []

      const availableSections = this.titles.map(t => t.text)
      if (!this.activeSections.hasOwnProperty(content.id)) {
        this.$set(this.activeSections, content.id, [])
        content.details.forEach(d => {
          if (availableSections.includes(d.title)) {
            this.activeSections[content.id].push(d.title)
          }
        })
      }

      // content.details.forEach(d => {
      //   // set tick for multiple select
      //   let title = this.titles.filter(t => t.text === d.title)[0]
      //   title.value.content = d.content
      //   this.prodTitle.push({...d, editContent: false})
      // })
      // this.$emit('contentID', content.id)
      this.content = content
    },
    fetchContent () {
      let id = this.$route.params.productID
      this.$axios.get(`/contents/?product=${id}&locale=${this.language}`)
        .then(resp => {
          this.content = resp.data.results[0]
          if (!resp.data.results[0].default_option) {
            this.content.default_option = {}
          }
          resp.data.results[0].details.forEach(d => {
            // set tick for multiple select
            let title = this.titles.filter(t => t.text === d.title)[0]
            title.value.content = d.content
            this.prodTitle.push({...d, editContent: false})
          })
          this.$emit('contentID', this.content.id)
        })
    },
    fetchDefaultOption () {
      let id = this.$route.params.productID
      this.$axios.get(`/options/?product=${id}&locale=${this.language}`)
        .then(resp => {
          resp.data.results.forEach(d => {
            let option = {text: 'RM ' + this.senToRM(d.sell_price) + ' - ' + d.title, value: d.id}
            this.defOptions.push(option)
          })
        })
    },
    fetchBenefits () {
      var id = this.$route.params.productID
      this.$axios.get(`/benefits/?ordering=id&product=${id}`)
        .then(resp => {
          this.allBenefits = [...resp.data.results]
        })
    },
    senToRM (val) {
      return (parseInt(val) / 100).toFixed(2)
    },
    submitContent () {
      let data = {
        status: this.content.status,
        name: this.content.name,
        slug: this.content.slug,
        page_title: this.content.page_title,
        page_description: this.content.page_description,
        special: this.content.special,
        details: this.content.details,
        itineraries: this.content.itineraries,
        unique_selling_points: this.content.unique_selling_points,
        default_option: this.content.default_option.id
      }
      this.$axios.patch(`/contents/${this.content.id}/`, data)
        .then(resp => {
          this.submitBenefits()
          // console.log(resp)
          this.$alert.success('Save Content Successful')
          // this.$showAlert('danger', 'test')
          this.$emit('save')
        })
        .catch(error => {
          console.log(error)
          this.$alert.failed('Save Content Unsuccessful')
        })
    },
    submitBenefits () {
      this.benefits.forEach(b => {
        if (b.id) {
          this.$axios.patch(`/benefits/${b.id}/`, {text: b.text})
            .catch(error => {
              console.log(error)
            })
        } else {
          let data = {
            text: b.text,
            product: this.$route.params.productID,
            locale: this.activeLanguage
          }
          this.$axios.post('/benefits/', data)
            .catch(error => {
              console.log(error)
            })
        }
      })
    },
    removeEditContent (val) {
      return {title: val.title, content: val.content}
    },
    removeBenefit (b, index) {
      this.$axios.delete(`/benefits/${b.id}/`)
        .then(resp => {
          this.$showAlert('grey darken-2', 'Remove Benefit Successful!')
        })
      this.allBenefits = this.allBenefits.filter(benefit => benefit.id !== b.id)
    },
    contentAdded (content) {
      this.contents.push(content)
      this.activeLanguage = content.locale.id
    },
    updateSections () {
      const oldDetails = this.content.details
      const newDetails = []
      this.activeSections[this.content.id] = [...this.titles.filter(t => this.activeSections[this.content.id].includes(t.text)).map(t => t.text)]
      this.titles.filter(t => this.activeSections[this.content.id].includes(t.text)).forEach(t => {
        if (oldDetails.filter(cd => cd.title === t.text).length === 0) {
          newDetails.push({ title: t.text, content : '' })
        } else {
          newDetails.push(oldDetails.filter(cd => cd.title === t.text)[0])
        }
      })
      this.$set(this.content, 'details', newDetails)
    },
    deleteContent () {
      this.$axios.delete(`/contents/${this.content.id}/`)
        .then(resp => {
          this.deleteDialog = false
          location.reload()
          this.$showAlert('success', 'Content delete success!')
        })
        .catch(error => {
          this.$showAlert('error', 'Error deleting content!')
        })
    }
  }
}
</script>

<style lang="scss">
.ql-align-center {
  text-align: center !important;
}

.copyw-image {
  width: 100%;
}
</style>